import React from 'react';
import { Teaser, Teasercollection } from '@ktag/styleguide/dist/react';
import { useTranslation } from 'react-i18next';

interface Props {
  careerUrl?: string;
  volksschuleUrl?: string;
  apprenticeshipUrl?: string;
}

const Topics = ({ careerUrl, volksschuleUrl, apprenticeshipUrl }: Props) => {
  const { t } = useTranslation('jobs');

  if (!careerUrl || !volksschuleUrl || !apprenticeshipUrl) return null;
  return (
    <>
      <span className="furthercontent--withdelimiter" />
      <h2 className="h4">{t('topics_title')}</h2>
      <Teasercollection type="list-horizontal" equalheight additionalClassNames="topics">
        <Teaser
          url={careerUrl}
          title={t('topics_career_title')}
          description={t('topics_career_description')}
          image={{
            srcs: {
              large: {
                url: `${process.env.PUBLIC_URL}/images/jobskarriere.jpg`,
              },
            },
          }}
        />
        <Teaser
          url={volksschuleUrl}
          title={t('topics_volksschule_title')}
          description={t('topics_volksschule_description')}
          external
          image={{
            srcs: {
              large: {
                url: `${process.env.PUBLIC_URL}/images/volksschule.jpg`,
              },
            },
          }}
        />
        <Teaser
          url={apprenticeshipUrl}
          title={t('topics_apprentice_title')}
          description={t('topics_apprentice_description')}
          image={{
            srcs: {
              large: {
                url: `${process.env.PUBLIC_URL}/images/lehrstellen.jpg`,
              },
            },
          }}
        />
      </Teasercollection>
    </>
  );
};

export default Topics;
